<template>
  <div>
    <pt-collapsible-sidebar
      ref="collapsibleSidebarRight"
      :width="1080"
      :overlay="true"
      :partial-collapse="false"
      position="right"
      class="holiday-sidebar"
    >
      <div slot="expanded" class="h-screen">
        <div class="mx-5">
          <header class="border-b flex flex-row items-center py-4">
            <span class="cursor-pointer mt-1" @click="toggle">
              <i class="fa fa-arrow-left mr-4 mb-1" aria-hidden="true" />
            </span>
            <h3 class="ml-2">Edit Schedule</h3>
          </header>
        </div>

        <div class="flex flex-col justify-between h-auto">
          <div class="mt-4 add-edit-schedule-scrollable-container border-b">
            <schedules-list
              :date-schedules="dateSchedules"
              :overlapped-days="overlappedDays"
              class="mb-8 mx-1 add-edit-schedule-scrollable-content"
              @updateSchedules="updateSchedules"
              @deleteSchedule="deleteSchedule"
              @emptyOverlappedDays="emptyOverlappedDays"
            />
          </div>

          <div>
            <div class="mx-5 mt-2 py-4">
              <pt-button
                :disabled="isLoading"
                :class="['primary-button', saveButtonStyle]"
                variant="primary"
                size="sm"
                @action="onSubmit"
              >
                Save Changes
              </pt-button>
              <pt-button
                :disabled="isLoading"
                class="ml-1 secondary-outline-button secondary-outline-button-dark-grey"
                variant="secondary-outline"
                size="sm"
                @action="toggle"
              >
                <p class="sidebar-cancel-button">Cancel</p>
              </pt-button>
            </div>
          </div>
        </div>
      </div>
    </pt-collapsible-sidebar>
    <response-modal
      ref="responseModal"
      :response="response"
      @onCloseModal="closeResponseModal"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { PtCollapsibleSidebar } from '@pathao/ui-components/esm/SidebarV1';
import SchedulesList from '@components/schedule/schedules-list.vue';
import isEmpty from 'lodash/isEmpty';
import removeDuplicates from '@utils/remove-duplicates-array-obj';
import ResponseModal from '@components/common/responseModal.vue';
import { RESPONSE_MODAL_DATA } from '@constants';
import capitalizeFirstLetter from '@utils/capitalize-first-letter';

export default {
  name: 'ScheduleAddEdit',
  components: {
    PtCollapsibleSidebar,
    SchedulesList,
    ResponseModal,
  },
  props: {
    info: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      dateSchedules: [{
        id: 1,
        opening_time: '00:00:00',
        closing_time: '23:59:59',
        days: [],
      }],
      updatedSchedulesObj: {},
      messageText: null,
      subtitleText: null,
      isSuccess: false,
      response: null,
      overlappedDays: [],
    };
  },
  computed: {
    saveButtonStyle() {
      return this.isLoading || !this.isSubmitAllowed ? 'primary-button-disabled' : 'primary-button-enabled';
    },
  },
  watch: {
    info(newVal, oldVal) {
      if (!isEmpty(newVal)) {
        this.dateSchedules = [ ...newVal ];
      }
    },
  },
  methods: {
    toggle() {
      this.$refs.collapsibleSidebarRight.toggle();
    },
    resetModalData() {
      this.response = null;
    },
    closeResponseModal() {
      this.resetModalData();
    },
    updateSchedules(schedule) {
      if (Array.isArray(schedule)) {
        schedule.forEach((item) => {
          this.updatedSchedulesObj[item.id] = item;
        });
      } else {
        this.updatedSchedulesObj[schedule.id] = schedule;
      }
    },
    deleteSchedule(index) {
      delete this.updatedSchedulesObj[index];
    },
    async onSubmit() {
      this.$sendEvent('RS_SaveScheduleChanges');
      const payloadSchedules = [];
      let isSubmitAllowed = true;
      Object.keys(this.updatedSchedulesObj).forEach((key) => {
        const eachDay = this.updatedSchedulesObj[key];
        if (isEmpty(eachDay.days) || isEmpty(eachDay.opening_time) || isEmpty(eachDay.closing_time)) {
          isSubmitAllowed = false;
          return;
        }
        this.updatedSchedulesObj[key].days.forEach((day) => {
          payloadSchedules.push({
            opening_time: this.updatedSchedulesObj[key].opening_time,
            closing_time: this.updatedSchedulesObj[key].closing_time,
            day,
          });
        });
      });
      if (!isSubmitAllowed) {
        this.isLoading = false;
        this.$notification.error('Please fill up all the required fields!');
        return;
      }
      const payload = {
        ...removeDuplicates(payloadSchedules),
      };
      this.isLoading = true;
      try {
        const response = await this.updateSchedule(payload);
        this.hasUpdated = true;
        this.isLoading = false;
        this.$emit('refreshList');
        this.toggle();
        if (!(response && response.data && response.data.message)) {
          this.$notification.success('Succesfully updated Business Schedule');
          return;
        }
        this.$notification.success(capitalizeFirstLetter(response.data.message));
        if (response.data.success || (response.data.code && response.data.code in RESPONSE_MODAL_DATA)) {
          this.response = response;
          this.$refs.responseModal.showModal();
        }
      } catch (error) {
        this.isLoading = false;
        if (!(error && error.response && error.response.data && error.response.data.message)) {
          this.$notification.error('Failed to update Business Schedule');
          return;
        }
        this.$notification.error(capitalizeFirstLetter(error.response.data.message));
        if (error.response.data.code && error.response.data.code in RESPONSE_MODAL_DATA) {
          if (error.response.data.code === 'FOOD_3000') {
            this.overlappedDays = error.response.data.data.overlapped_schedules;
          }
          this.response = error.response;
          this.$refs.responseModal.showModal();
        }
      }
    },
    emptyOverlappedDays() {
      this.overlappedDays = [];
    },
    ...mapActions({
      updateSchedule: 'schedules/updateSchedule',
      fetchScheduleList: 'schedules/fetchScheduleList',
    }),
  },
};
</script>
